module.exports = __webpack_public_path__ + "static/wordmark-black-0a871f0c37bc5b7832d90528bb1c1e38.svg";